/* @flow */

import loadable from '@loadable/component';

export default loadable(() =>
  import(
    /* webpackChunkName: "__connect-on-interests" */ './ConnectOnInterest'
  ),
);
